/**
 * 认证相关的API调用
 */
import axios from 'axios';

// 根据环境自动选择API地址
const isDevelopment = window.location.hostname === 'localhost' && window.location.port === '3000';
const API_BASE = isDevelopment ? 'http://localhost:8000' : '/api';

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：自动添加token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('lda_auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理401错误
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // token过期或无效，清除本地存储并跳转到登录页
      localStorage.removeItem('lda_auth_token');
      window.location.href = '/lda/login';
    }
    return Promise.reject(error);
  }
);

/**
 * 用户注册
 * @param {string} phone - 手机号
 * @param {string} password - 密码
 * @returns {Promise} 返回token和用户信息
 */
export const register = async (phone, password) => {
  const response = await apiClient.post('/auth/register', {
    phone,
    password,
  });
  return response.data;
};

/**
 * 用户登录
 * @param {string} phone - 手机号
 * @param {string} password - 密码
 * @returns {Promise} 返回token和用户信息
 */
export const login = async (phone, password) => {
  const response = await apiClient.post('/auth/login', {
    phone,
    password,
  });
  return response.data;
};

/**
 * 获取当前用户信息
 * @returns {Promise} 返回用户信息
 */
export const getCurrentUser = async () => {
  const response = await apiClient.get('/auth/me');
  return response.data;
};

export default apiClient;
